export default "__VITE_ASSET__BE$0Tq1M__"